export default __webpack_public_path__ + "static/media/FOTO-11.03c9e266.jpg";